import React, { useState, useEffect } from 'react'
import './Transmission.css';
import { BiPlusMedical, BiSearchAlt } from 'react-icons/bi';
import { GoCloudDownload } from 'react-icons/go';
import { AiOutlineFileExcel } from 'react-icons/ai';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useNavigate } from 'react-router-dom';
import CustomDatatableTransmission from '../../components/CustomDatatableTransmission/CustomDatatableTransmission';
import AddOrViewTransmission from '../../components/AddOrViewTransmission/AddOrViewTransmission';
import Navbar from '../../appShell/Navbar/Navbar';
import Sidebar from '../../appShell/Sidebar/Sidebar';
import { handleMenuSelection, searchFunction } from '../../utils/utils';
import { getTaux, getTransmissionsYears } from '../../services/http';
import Loader from '../../components/Loader/Loader';
import io from "socket.io-client"

const Transmission = () => {


  let months = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"]

  const anneeTransmission = [
    { id: 2022, label: "2022" },
    { id: 2021, label: "2021" }
  ]

  const tableColumns = [
    { id: "1", label: "#" },
    { id: "2", label: "Mois" },
    { id: "3", label: "Date de transmission" },
    { id: "4", label: "Statut" }
  ]

  const tableAddColumns = [
    { id: "1", label: "#" },
    { id: "2", label: "Produit" },
    { id: "3", label: "Taux" }
  ]

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const [pageNumber, setPageNumber] = useState(1);
  const [perPage, setPerPage] = useState(15);
  const [totalPage, setTotalPage] = useState(1);


  const states = useSelector((state) => state, shallowEqual);

  const [transmissionYear, setTransmissionYear] = useState();
  const [yearSelected, setYearSelected] = useState();
  const [displayLoader, setDisplayLoader] = useState(true);

  //  To populate the breadcrumb and update the sidebar menu
  useEffect(() => {
    dispatch({
      type: "SET",
      key: "breadcrumbContent",
      payload: {
        firstLevelText: "Transmission", firstLevelLink: "/transmission", secondLevelText: "", secondLevelLink: "", thirdLevelText: "", thirdLevelLink: ""
      }
    });
    handleMenuSelection("transmission", dispatch, states);
    // handleSubMenuSelection("institutions", dispatch)
  }, [])

  const [showEditTransmission, setShowEditTransmission] = useState(false);

  const loadTransmissionYears = async () => {
    const resp = await getTransmissionsYears(states.userToken.access_token);
    if (resp.response && resp.response.status !== 200) {
      console.log("data error ", resp.response)
    } else {
      console.log("data data ", resp.data)

      setTransmissionYear(resp.data)
      console.log(resp.data)
      setYearSelected(resp.data[0]?.annee)
      console.log(yearSelected)

    }

  }

  useEffect(() => {
    loadTransmissionYears();

  }, [])

  const handleShowNewTransmission = () => {
    navigate("/transmission/new")
  };

  const goToImportScreen = () => {
    navigate("/import-transmission")
  }

  const fetchTransmissions = async () => {
    console.log("Goood fetch", yearSelected.annee)
    let taux_list_response = await getTaux(states.userToken.access_token, yearSelected.annee, pageNumber);
    let taux_list_response_copy = taux_list_response?.data?.data?.map(obj => ({ ...obj, showEdit: false, showDelete: false }))
    console.log("Top ", taux_list_response)
    const total = taux_list_response?.data?.total;
    const perPageValue = taux_list_response?.data?.per_page
    setTotalPage(Math.ceil(total / perPage))
    setPerPage(perPageValue)
    dispatch({
      type: "SET",
      key: "transmissionList",
      payload: taux_list_response_copy,
    });
    setDisplayLoader(false);
  }

  useEffect(() => {
    console.log("Goood effect", yearSelected)
    if(yearSelected?.annee){
      fetchTransmissions()
    }
  }, [pageNumber, yearSelected])

  useEffect(async () => {
    
    let taux_list_response = await getTaux(states.userToken.access_token, yearSelected, pageNumber);
    let taux_list_response_copy = taux_list_response.data?.data?.map(obj => ({ ...obj, showEdit: false, showDelete: false }))
    console.log("Top ", taux_list_response)
    if (taux_list_response.status == 200) {
      const total = taux_list_response?.data?.total;
      const perPageValue = taux_list_response?.data?.per_page
      setTotalPage(Math.ceil(total / perPage))
      setPerPage(perPageValue)
      if(yearSelected){
        dispatch({
          type: "SET",
          key: "transmissionList",
          payload: taux_list_response_copy,
        });
        setDisplayLoader(false);
      }
    }
    console.log("Good 3", yearSelected)
  }, [yearSelected])

  const changePage = ({ selected }) => {
    let currentPage = selected + 1;
    setPageNumber(currentPage)
}

  // const handleYearSelected = async () => {
  //   console.log(yearSelected)
  //   let taux_list_response = await getTaux(states.userToken.access_token, yearSelected.annee);
  //   let taux_list_response_copy = taux_list_response.data.map(obj => ({ ...obj, showEdit: false, showDelete: false }))
  //   console.log(taux_list_response)
  //   dispatch({
  //     type: "SET",
  //     key: "transmissionList",
  //     payload: taux_list_response_copy,
  //   });
  // };


  return (
    <div>
      <Navbar />
      <div className="main-container" id="container">
        <Sidebar />

        <div id="content" className="main-content">
          <div className="layout-px-spacing">

            <div className="row layout-top-spacing">
              <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
              </div>
            </div>

            <div className="">
              {/* <AddOrViewTransmission data={transmissionListToAdd} columns={tableAddColumns} showAddTransmission={states.showNewTransmission} handleCloseAddTransmission={handleCloseNewTransmission} /> */}
              <h2 className="mb-3 text-left">Liste des transmissions</h2>
              {displayLoader == false ?
                <div className="widget widget-content widget-content-area">
                  <div className="dataTables_wrapper  dt-bootsrap4">
                    <div className="dt--top-section container-fluid mt-4 pt-3 px-3">
                      <div className="row">
                        <div className="col-12 col-sm-6 d-flex justify-content-sm-start justify-content-center mb-3">
                          <div className="d-flex">
                            <label for="annee" className="mr-2 pt-1">Année : </label>
                            <select onChange={(e) => setYearSelected(e.target.value)} className="form-control custom-form-control mx-auto year-selector custom-select">
                              {transmissionYear && transmissionYear.map((item) => (
                                <option key={item.annee} value={item.annee}>{item.annee}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-12 col-sm-6 d-flex justify-content-sm-end justify-content-center mt-sm-0 mt-3 mb-3">
                         {states.userPermissions?.send_transmission !== undefined && <div>
                            <button className="btn btn-info  btn-xs mb-2" onClick={() => handleShowNewTransmission()}> <BiPlusMedical className="" /> Nouvelle </button>
                            <button className="btn btn-dark  ml-3 btn-xs mb-2" onClick={goToImportScreen}><AiOutlineFileExcel className="mr-1" />Importer</button>
                          </div>}
                        </div>
                      </div>
                    </div>
                    {states.transmissionList && states.transmissionList.length != 0 ?
                      <CustomDatatableTransmission columns={tableColumns}
                        data={states.transmissionList}
                        showEditTransmission={showEditTransmission}
                        changePage={changePage}
                        pageCount={totalPage}
                        pageNumber={pageNumber}
                        perPage={perPage}
                      /> :
                      <h4 className="py-3">Aucune Transmission</h4>
                    }
                  </div>
                </div> : <div style={{ marginTop: "25%" }}>
                  <Loader />
                </div>}
            </div>

          </div>

        </div>
      </div>
    </div>
  )
}

export default Transmission